import React from 'react';
import firstPic from 'images/content/personr_sss.png'
import priceSec from 'images/content/price-sec.jpg'

const SeventhSection = () => {
    return (
        <div className='flex flex-col items-center gap-y-4'>
            <div className='text-2xl sm:text-4xl font-bold'>Sample Monthly Premiums</div>
            <div className='flex flex-col lg:flex-row items-center justify-center w-full gap-4'>
                <div className='max-w-lg w-full shadow-xl border border-zinc-500'><img src={firstPic} alt='Content' className='w-full' /></div>
                <div className='max-w-lg w-full shadow-xl'><img src={priceSec} alt='phcsLogo' className='w-full' /></div>
            </div>
        </div>
    );
}

export default SeventhSection;
